<figure class="santa-m-0 santa-inline-block santa-pointer-events-none santa-align-middle" [style.width]="getWidth" [innerHTML]="state.svgElement || '' | bypassSanitizer: 'html'"></figure>
